import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "clients-panel" }

import {
	onMounted,
	ref
} from "vue";
import ClientsPanelFilters from "@/components/main/clients-panel/ClientsPanelFilters.vue";
import ClientsPanelList from "@/components/main/clients-panel/ClientsPanelList.vue";
import {
	ClientRequestData,
	clientsStore
} from "@/store/clients";
import { provideContactsContext } from "@/composables/useContactsContext";
import { TagWithFrequency } from "@/models/interfaces/tags/tag-models";
import { RequestAddressContainer } from "@/composables/useAddressRequest";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientsPanel',
  setup(__props) {

const cStore = clientsStore()

const filters = ref({
	searchStr: '',
	inputContainer: null as RequestAddressContainer | null,
	toSkip: 0,
	count: 30
})
const selectedTags = ref<TagWithFrequency[]>([])
const appliedSearchText = ref('')

const buildRequest = (): ClientRequestData => ({
	...filters.value,
	tags: selectedTags.value.length ? selectedTags.value.map(t => t.Id) : null,
})

provideContactsContext({
	context: 'main',
	showExistContacts: async (contactIds, contactText) => {
		appliedSearchText.value = contactText
		await cStore.getExistContacts(contactIds)
	},
})

onMounted(async () => {
	await searchClients()
})

const searchClients = async (address?: RequestAddressContainer | null) => {
	if (address !== undefined) {
		filters.value.inputContainer = address
	}
	filters.value.toSkip = 0
	appliedSearchText.value = filters.value.searchStr
	await cStore.fetchClients(buildRequest())
}

const fetchPartial = async () => {
	filters.value.toSkip += filters.value.count
	await cStore.fetchClients(buildRequest())
}

const onSelectedTagsUpdate = (next: TagWithFrequency[]) => {
	const wasEmpty = !selectedTags.value.length
	selectedTags.value = next
	if (!next.length && !wasEmpty) {
		searchClients()
	}
}

const dropTag = (tag: TagWithFrequency) => {
	selectedTags.value = selectedTags.value.filter(t => t.Id !== tag.Id)
	if (!selectedTags.value.length) {
		searchClients()
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ClientsPanelFilters, {
      modelValue: filters.value.searchStr,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.searchStr) = $event)),
      "selected-tags": selectedTags.value,
      onOnSearch: searchClients,
      "onUpdate:selectedTags": onSelectedTagsUpdate,
      onDropTag: dropTag
    }, null, 8, ["modelValue", "selected-tags"]),
    _createVNode(ClientsPanelList, {
      onOnGetPartial: fetchPartial,
      "search-text": appliedSearchText.value
    }, null, 8, ["search-text"])
  ]))
}
}

})